/**
 * Hamma soat uchun bitta taymer: daqiqa (yoki soniya) chegarasida yangilanadi, yashirin tabda to'xtaydi, qaytganda
 * darhol yangilanadi. Qiymat chegaraga yaxlitlangan -- bir davr ichida bir xil (useSyncExternalStore uchun barqaror).
 */
import { useMemo, useSyncExternalStore } from "react";

export type Tick = "second" | "minute";
const PERIOD: Record<Tick, number> = { second: 1000, minute: 60_000 };

interface Clock {
  listeners: Set<() => void>;
  timer: number | null;
}
const clocks: Record<Tick, Clock> = {
  second: { listeners: new Set(), timer: null },
  minute: { listeners: new Set(), timer: null },
};

function notify(tick: Tick) {
  clocks[tick].listeners.forEach((l) => l());
}

function schedule(tick: Tick) {
  const c = clocks[tick];
  if (c.timer !== null) window.clearTimeout(c.timer);
  c.timer = null;
  if (!c.listeners.size || document.visibilityState === "hidden") return;
  const period = PERIOD[tick];
  // Chegaradan biroz keyin: yaxlitlangan qiymat aniq yangi davrga tushsin
  c.timer = window.setTimeout(() => {
    notify(tick);
    schedule(tick);
  }, period - (Date.now() % period) + 15);
}

function onVisibility() {
  for (const tick of Object.keys(clocks) as Tick[]) {
    if (document.visibilityState === "visible") notify(tick);
    schedule(tick);
  }
}

function subscribe(tick: Tick, listener: () => void) {
  const c = clocks[tick];
  if (!clocks.second.listeners.size && !clocks.minute.listeners.size) document.addEventListener("visibilitychange", onVisibility);
  c.listeners.add(listener);
  if (c.listeners.size === 1) schedule(tick);
  return () => {
    c.listeners.delete(listener);
    if (!c.listeners.size) schedule(tick);
    if (!clocks.second.listeners.size && !clocks.minute.listeners.size) document.removeEventListener("visibilitychange", onVisibility);
  };
}

export function useNow(tick: Tick = "minute"): Date {
  const period = PERIOD[tick];
  const ms = useSyncExternalStore(
    (l) => subscribe(tick, l),
    () => Math.floor(Date.now() / period) * period,
  );
  return useMemo(() => new Date(ms), [ms]);
}
